<template>
  <div class='tinymce' v-drag>
    <editor id='tinymce'  v-model='value' :init='init'></editor>
    <!--  v-model='value'-->
    <div class="footer_tinymce">
      <input class="size_num" type="number" placeholder="填写默认字号" v-model="default_num">
      <button class="btn_true_tinymce" @click="submit">确认</button>
      <button class="btn_false_tinymce" @click="cancel">取消</button>
      <!-- <div style="font-size:12px">qwep<p style="font-size:50px">sdgaga</p></div> -->
    </div>
  </div>
</template>

<script>
import tinymce from 'tinymce/tinymce'
import Editor from '@tinymce/tinymce-vue'
import 'tinymce/themes/silver/theme.min.js'
import 'tinymce/icons/default/icons'
import 'tinymce/plugins/link'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/image'
import 'tinymce/plugins/code'
import 'tinymce/plugins/table'
import 'tinymce/plugins/wordcount'
import 'tinymce/plugins/preview'
import 'tinymce/plugins/media'
import 'tinymce/plugins/charmap'
import 'tinymce/plugins/print'
import 'tinymce/plugins/anchor'
import 'tinymce/plugins/searchreplace'
import 'tinymce/plugins/visualblocks'
import 'tinymce/plugins/fullscreen'
import 'tinymce/plugins/insertdatetime'
import 'tinymce/plugins/paste'
import 'tinymce/plugins/help'

import '../../public/static/tinymce/skins/ui/oxide/skin.min.css'
import '../../public/static/tinymce/skins/ui/oxide/content.inline.min.css'
import '../../public/static/tinymce/zh_CN.js'
export default {
  
  name: 'tinymce',
  props: [
    'editorData',
    'rule_data',
    'language_params'
  ],
  components: {
    Editor
  },
  data () {
    return {
      init: {
        height: 500,
        plugins: 'link | insertdatetime',
        //lists image code table wordcount preview media  charmap print anchor searchreplace visualblocks fullscreen insertdatetime help
        // toolbar: ' bold italic underline strikethrough | fontselect | fontsizeselect | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent blockquote | undo redo | link unlink image code | removeformat',
        toolbar: ' bold italic | fontsizeselect | forecolor | link unlink | removeformat | insertdatetime',
        menubar: 'file edit',
        insertdatetime_formats:["%Y-%m-%d ","%H:%M:%S"],
        theme_advanced_buttons3_add : "insertdate,inserttime",
        // language_url: '../../static/tinymce/zh_CN.js',
        language: 'zh_CN',
        // init_instance_callback: "insert_contents",
        content_css: false,
        // skin_url: '../../static/tinymce/skins/ui/oxide'
        // convert_fonts_to_spans : false,// 转换字体元素为SPAN标签，默认为true
        // extended_valid_elements: "span",// 不允许使用的元素类型
        // block_formats:'Paragraph=size',
        // encoding: 'xml'
        // extended_valid_elements :'size[id],size',
        // custom_elements : 'size,~size',
        // forced_root_block : 'size',
        // br_in_pre: false,
        // end_container_on_empty_block: true,
        // remove_trailing_brs: false,
    //     forced_root_block_attrs: {
    //     '': '=12pt',
    //    },
  // valid_children : '+body[style],-body[div],size[b|i|color|a|#text]',
  // valid_classes: {
  //       'size': 'style', //全局可以拥有的class值
  //   }
      // valid_elements : 'a[href|target=_blank]',
      
      },
       default_num:28,
       value:this.rule_data,//父组件通过ref拿到该组件的值
       stra:''
    }
  },
  computed:{
    
  },
  created(){
    tinymce.init({});
  },
  mounted () {
    // console.log(this.language_params)
    // alert(0)
    // this.edit_import();   
  },
  methods:{
    //将unity标签颜色属性转换为html标签颜色属性
    e_value_color(str){
      // console.log(str)
      var value=str.match(/#+\w+/gi);
      if(value){
        value.forEach((item,index)=>{
          str=str.replace(/<size><color=#+\w+>/,'<span style="color: '+value[index]+';">')
          //  str=str.replace(/<size=\d+><color=#+\w+>/,'<span style="color: '+value[index]+';">')
        })
      }
      // console.log(str)
      return str
    },
    //将unity标签字体大小属性转换为html标签字体大小属性
    e_value_size(str){
      // alert(0)
      if(str.match(/\d+\>/gi)){
        // console.log(str)
        var numValue=str.match(/size=\d+\>/gi).join().match(/\d+/gi);
        // if(numValue!=this.default_num){
          // console.log(numValue)
          if(str.match(/<size=\d+><color=#+\w+>/gi)){
                var numColorValue=str.match(/<size=\d+><color=#+\w+>/gi).join().match(/<size=\d+\>/gi).join().match(/\d+/gi)
                // console.log(numColorValue)
              }
          numValue.forEach((item,index)=>{
            // console.log(numValue[index],this.default_num)
            if(item!=this.default_num){
              if(numColorValue){
                numColorValue.forEach((test,i)=>{
                  if(item!=test){
                    // console.log(item)
                    str=str.replace(/<size=\d+><color>/,'<span style="font-size: '+(Number(numValue[index])-Number(this.default_num)+12)+'pt;">')
                  }
                })
              }else{
                str=str.replace(/<size=\d+><color>/,'<span style="font-size: '+(Number(numValue[index])-Number(this.default_num)+12)+'pt;">')
              }
             
              
              
              // console.log(str)
            }
              
          
        })
        
      }
      // console.log(str)
      return str
    },
    //获取第一个size的值
    e_first_value(str){
      // console.log(str)
      if(str.match(/<size=\d+>/)){
        var first_value=str.match(/<size=\d+>/).join().match(/\d+/)
        // console.log(first_value)
        this.default_num=Number(first_value[0])
      }
    },
    //将unity标签字体大小和颜色属性属性转换为html标签字体大小属性和颜色属性(转移过后总是将字体属性写在前面)
    e_value_size_color(str){
      // console.log((str))
      if(str.match(/<size=\d+><color=#+\w+>/gi)){
        var numColorValue=str.match(/<size=\d+><color=#+\w+>/gi).join().match(/<size=\d+\>/gi).join().match(/\d+/gi)
        // console.log(numColorValue)
      }        
      if(str.match(/<size=\d+><color=#+\w+>/gi)){
        var numValueColor=str.match(/<size=\d+><color=#+\w+>/gi).join().match(/#+\w+/gi)
      }
      if(numColorValue){
        // alert(0)
        // console.log(numColorValue)
        // console.log(str)
        numColorValue.forEach((item,index)=>{
          if(item==this.default_num){
            str=str.replace(/<size=\d+><color=#+\w+>/,'<span style="color: '+numValueColor[index]+';">')       
          }else{
            str=str.replace(/<size=\d+><color=#+\w+>/,'<span style="font-size: '+(Number(numColorValue[index])-Number(this.default_num)+12)+'pt; color: '+numValueColor[index]+';">')
          }
        })
      }
      return str
    },
    //将unity中带a标签的属性并且带有颜色属性替换
    e_value_color_a(str){
      if(str.match(/<color=#+\w+><a/gi)){
        var aValue=str.match(/<color=#+\w+><a/gi).join().match(/#+\w+/gi);
        aValue.forEach((item,index)=>{
          str=str.replace(/<span style="color: #+\w+";><a/,'<span style="color: '+aValue[index]+';"><a style="color: '+aValue[index]+';"')
        })
      }
      return str
    },
    //将unity中带a标签的属性并且带有颜色属性和字体大小属性替换
    e_value_size_color_a(str){
      if(str.match(/<size=\d+><color=#+\w+><a/gi)){
        var aValueNum=str.match(/<size=\d+><color=#+\w+><a/gi).join().match(/<size=\d+\>/gi).join().match(/\d+/gi);
        var aValuecolor=str.match(/<size=\d+><color=#+\w+><a/gi).join().match(/#+\w+/gi);
        aValueNum.forEach((item,index)=>{
          str=str.replace(/<span style="font-size: \d+pt; color: #+\w+;"><a/,'<span style="font-size: '+aValueNum[index]+'pt; color: '+aValuecolor[index]+';"><a style="color: '+aValuecolor[index]+';"')
        })
      }
      return str

    },
    // e_url_a(str){
    //   console.log(str)
    //   // console.log(str.match(/(https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/))
    //   console.log(str.match(/href=[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/gi))
    //   var ea=str.match(/href=[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/gi);
    //   var ee=[];
    //   if(ea){
    //     ea.forEach((item,index)=>{
    //       ee.push(item.replace(/href=/,''))
    //     })
    //     console.log(str)
    //     ee.forEach((item,index)=>{
    //       str.replace(/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/,'<a href="http://'+item+'"')
    //     })
    //     // var url_a=str.match(/(https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/)[0]
    //     // str=str.replace(/(https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/,'href="'+url_a+'"')
    //   }
    //   console.log(str)
    //   return str
    // },
    //编辑时把0时区时间转成当前时区的时间
    conversion_time_character(value_c){
      // let time_zone=new Date().toString().split(' ');
      // time_zone=time_zone[time_zone.length-2];
      // time_zone=time_zone.replace(/GMT/,'UTC');
      let time_zone=window.sessionStorage.getItem('time_zone');
      let value=value_c.match(/[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d/);
      if(value){
        value=value[0]+' '+'UTC+0000';
        value=this.change_time_zone(value)
        value=this.datetime2zone_x(value,time_zone)
        value=value.replace(/\s+UTC+(\-|\+)\d+/,'')

        return value_c.replace(/[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d/,value);
        // value_c.replace()
      }
      return value_c
    },



    //编辑导入数据
//     edit_import(){
//       // console.log(this.value)
//       // this.e_first_value(this.value)
//       if(this.value){
// this.e_first_value(this.value)
//         // if(){}
//         this.value=this.value.replace(/<\/color><\/size>/gi,'</span>')
//         if(this.value.indexOf('<color')){
//           this.value=this.e_value_color(this.value);
//           this.value=this.e_value_size(this.value);
         
//           this.value=this.e_value_size_color(this.value);
         
//           this.value=this.e_value_color_a(this.value);
//           this.value=this.e_value_size_color_a(this.value);
//           // console.log(this.value)
//           // this.value=this.e_url_a(this.value);
//           this.value=this.conversion_time_character(this.value);
//         }
//         // console.log(this.value)
//         // this.value=this.value.replace(/<size>/gi,'<p>')
//         this.value=this.value.replace(/<size=\d+>/gi,'<p>')
//         this.value=this.value.replace(/<\/size>/gi,'</p>')
//         // console.log(this.value)
//       }
//     } ,



    //将html标签转换成unity标签
    z_label(str){
      console.log(str)
      str=str.replace(/(\<p|\<\/p|\<span|\<\/span\>|\<strong|\<\/strong|\<em|\<\/em)/gi,function($0,$1){
        return {
          '<p':'<size',
          '</p':'</size',
          '<span':'<size><color',
          '</span>':'</color></size>',
          '<strong':'<b',
          '</strong':'</b',
          '<em':'<i',
          '</em':'</i',
        }[$1]
      });
      // console.log(str)
      return str
    },
    //获取所有的16进制颜色值
    z_value_color(str){
      // console.log(str)
      var value_a=str.match(/\<size\>\<color style="color: #+\w+;"\>/gi);
      if(value_a){
        var value_b=value_a.join().match(/#+\w+/gi)
      }      
      var value=str.match(/#+\w+/gi);//获取所有的16进制颜色值
      if(value_b){//如果只有颜色属性
      // console.log(value_b)
      // console.log(value)
        // value_b.forEach((item,index)=>{
          for(var item=0;item<value_b.length;item++){
          // value.forEach((item1,index1)=>{
            // for(var item1=0;item1<value.length;item1++){
              // alert(1)
              // if(item==item1){
                // alert(0)
                str=str.replace(/\<size\>\<color style="color: #+\w+;"\>/,'<size><color='+value_b[item]+'>');
                // break
              // } 
            // }           
          // })
        // })  
      }       
      }
      // console.log(str)
      return str
    },
    //获取所有的字体大小值
    z_value_size(str){
      var value_a=str.match(/\<size\>\<color style="font-size: \d+pt;"\>/gi);
      if(value_a){
        var value_b=value_a.join().match(/\d+pt/gi);
        var value_c=value_b.join().replace(/pt/gi,'').split(',');
      }
      //获取所有的字体大小值
      var numValue=str.match(/\d+pt/gi)
      if(value_a){
        numValue=numValue.join().replace(/pt/gi,'').split(',');
        value_c.forEach((item,index)=>{
          numValue.forEach((item1,index1)=>{
            if(item==item1){
              str=str.replace(/\<size\>\<color style="font-size: \d+pt;"\>/,'<size='+(Number(this.default_num)+Number(numValue[index1])-12)+'><color>');
            }
          })
        })
      }
      return str
    },
    //将所有没有默认值的size设置默认值
    z_value_default_size(str){
      str=str.replace(/\<size\>/gi,'<size='+this.default_num+'>');
      return str
    },
    //先写字体大小再写颜色的状态
    z_value_size_color(str){
      var numColorValue=str.match(/\<size\>\<color style="font-size: \d+pt; color: #+\w+;"\>/gi)//先写字体大小再写颜色的状态
      if(numColorValue){
        var numColorValue_c=numColorValue.join().match(/#+\w+/gi);
        var numColorValue_n=numColorValue.join().match(/\d+pt/gi);
        numColorValue_n=numColorValue_n.join().replace(/pt/gi,'').split(',');
        numColorValue.forEach((item,index)=>{
          str=str.replace(/\<size\>\<color style="font-size: \d+pt; color: #+\w+;"\>/,'<size='+(Number(this.default_num)+Number(numColorValue_n[index])-12)+'><color='+numColorValue_c[index]+'>');
        })
      } 
      return str
    },
    //先写颜色再写字体大小的状态
    z_value_color_size(str){
      var numValueColor=str.match(/\<size\>\<color style="color: #+\w+; font-size: \d+pt;"\>/gi)//先写颜色再写字体大小的状态
      if(numValueColor){
        var numValueColor_c=numValueColor.join().match(/#+\w+/gi);
        var numValueColor_n=numValueColor.join().match(/\d+pt/gi);
        numValueColor_n=numValueColor_n.join().replace(/pt/gi,'').split(',');
        numValueColor.forEach((item,index)=>{
          str=str.replace(/\<size\>\<color style="color: #+\w+; font-size: \d+pt;"\>/,'<size='+(Number(this.default_num)+Number(numValueColor_n[index])-12)+'><color='+numValueColor_c[index]+'>');
        })
      }
      return str
    },
    //如果有a标签将其style属性替换为空
    z_value_a(str){
      // console.log(str)
      var aValue=str.match(/\<a style="color: #+\w+;"/gi);//如果有a标签将其style属性替换为空
      var value_1=str.match(/\<a href="\S*?"/gi);
      // console.log(aValue.join().match(/#+\w+/gi))
      
      if(aValue){
        var bValue=aValue.join().match(/#+\w+/gi);
        str=str.replace(/\<a style="color: #+\w+;"/gi,'<a');
        
      }
      var at=str.match(/\<a title="\w+"/);//如果有title属性就把它替换为空
      if(at){
        str=str.replace(/\<a title="\w+"/gi,'<a');
      }




      var cvalue=str.match(/<a[\S|\s]*?>\S*?</gi);
      // console.log(cvalue)
      var zvalue=str.match(/<a[\S|\s]*?>/gi);
      if(cvalue){
        var fvalue=cvalue.join().replace(/<a[\S|\s]*?>/gi,'').split(',')
      }
      


      // console.log(fvalue)
      // console.log(bValue)
      // console.log(value_1)
      // console.log(zvalue)
      // var dvalue=fvalue.join().match(/\S*?</gi)
      if(aValue||value_1){
        // for (var i=0;i<bValue.length;i++){
        //   str=str.replace(/<a[\S|\s]*?>\S*?<\/a>/,'<gg>');
        //   // str=str.replace(/<gg>/,zvalue[i]+'<color='+bValue[i]+'>'+fvalue[i]+'/color></a>');
        // }
        // for (var i=0;i<bValue.length;i++){
        //   // console.log(bValue[i])
        //   // str=str.replace(/<a[\S|\s]*?>\S*?<\/a>/,'<gg>');
        //   // str=str.replace(/<gg>/,zvalue[i]+'<color='+bValue[i]+'>'+fvalue[i]+'/color></a>');
        //   str=str.replace(/<gg>/,zvalue[i]+'<color=#154C77>'+fvalue[i]+'/color></a>');
        // }

        for (var i=0;i<fvalue.length;i++){
          str=str.replace(/<a[\S|\s]*?>\S*?<\/a>/,'<gg>');
          // str=str.replace(/<gg>/,zvalue[i]+'<color='+bValue[i]+'>'+fvalue[i]+'/color></a>');
        }
        for (var i=0;i<fvalue.length;i++){
          // console.log(bValue[i])
          // str=str.replace(/<a[\S|\s]*?>\S*?<\/a>/,'<gg>');
          // str=str.replace(/<gg>/,zvalue[i]+'<color='+bValue[i]+'>'+fvalue[i]+'/color></a>');
          str=str.replace(/<gg>/,zvalue[i]+'<color=#154C77>'+fvalue[i]+'/color></a>');
        }
      }
      // else if(value_1){
      //   for (var i=0;i<value_1.length;i++){
      //     str=str.replace(/<a[\S|\s]*?>\S*?<\/a>/,'<gg>');
      //   }
      //   for (var i=0;i<value_1.length;i++){
      //     str=str.replace(/<gg>/,zvalue[i]+'<color=#154C77>'+fvalue[i]+'/color></a>');
      //   }
      // }
      // zvalue[i]+'<color='+bValue[i]+'>'+fvalue[i]+'/color></a>'




      this.stra=str.match(/<a[\S|\s]*?>\S*?<\/a>/gi);
      str=str.replace(/<a[\S|\s]*?>\S*?<\/a>/gi,'<gg>');
      return str
    },

    // //如果有a标签将其style属性替换为空
    // z_value_a(str){
    //   var aValue=str.match(/\<a style="color: #+\w+;"/gi);//如果有a标签将其style属性替换为空
      
    //   if(aValue){
    //     var bValue=aValue.join().match(/#+\w+/gi);
    //     str=str.replace(/\<a style="color: #+\w+;"/gi,'<a');
    //   }
    //   var at=str.match(/\<a title="\w+"/);//如果有title属性就把它替换为空
    //   if(at){
    //     str=str.replace(/\<a title="\w+"/gi,'<a');
    //   }
    //   var cvalue=str.match(/<a[\S|\s]*?>\S*?</gi);
    //   var zvalue=str.match(/<a[\S|\s]*?>/gi);
    //   var fvalue=cvalue.join().replace(/<a[\S|\s]*?>/gi,'').split(',')
    //   if(bValue){
    //     for (var i=0;i<bValue.length;i++){

    //       str=str.replace(/<a[\S|\s]*?>\S*?<\/a>/,'<gg>');
          

    //     }
    //     for (var i=0;i<bValue.length;i++){
      
    //       str=str.replace(/<gg>/,zvalue[i]+'<color='+bValue[i]+'>'+fvalue[i]+'/color></a>');

    //     }
    //   }
     



      
    //   this.stra=str.match(/<a[\S|\s]*?>\S*?<\/a>/gi);
    //   str=str.replace(/<a[\S|\s]*?>\S*?<\/a>/gi,'<gg>');
    //   return str
    // },

    //计算时区时间
			datetime2zone_x(_date_time, _zone) {
				//定义utc时区字段
				const UTC_ZONE = {
				    "UTC-0000": -0 * 3600 * 1000,
				    "UTC-0100": -1 * 3600 * 1000,
				    "UTC-0200": -2 * 3600 * 1000,
				    "UTC-0300": -3 * 3600 * 1000,
				    "UTC-0400": -4 * 3600 * 1000,
				    "UTC-0500": -5 * 3600 * 1000,
				    "UTC-0600": -6 * 3600 * 1000,
				    "UTC-0700": -7 * 3600 * 1000,
				    "UTC-0800": -8 * 3600 * 1000,
				    "UTC-0900": -9 * 3600 * 1000,
				    "UTC-1000": -10 * 3600 * 1000,
				    "UTC-1100": -11 * 3600 * 1000,
				    "UTC-1200": -12 * 3600 * 1000,
				    "UTC+0000": 0 * 3600 * 1000,
				    "UTC+0100": 1 * 3600 * 1000,
				    "UTC+0200": 2 * 3600 * 1000,
				    "UTC+0300": 3 * 3600 * 1000,
				    "UTC+0400": 4 * 3600 * 1000,
				    "UTC+0500": 5 * 3600 * 1000,
				    "UTC+0600": 6 * 3600 * 1000,
				    "UTC+0700": 7 * 3600 * 1000,
				    "UTC+0800": 8 * 3600 * 1000,
				    "UTC+0900": 9 * 3600 * 1000,
				    "UTC+1000": 10 * 3600 * 1000,
				    "UTC+1100": 11 * 3600 * 1000,
				    "UTC+1200": 12 * 3600 * 1000
				};
				//如果参数返回false返回的显示字段
			    if (!_date_time){
					return "N/A";
					}
				//时区毫秒数
			    var office = UTC_ZONE[_zone];
			    var temp_date = null;
			    if (typeof _date_time == "string") {
					//如果参数是最初时间
			        if (_date_time == "1970-01-01 00:00:00"){
						 return "N/A";
					}
			        //如果参数是0000 
					if (_date_time == "0000-00-00 00:00:00"){
						 return "N/A";
					}
			        //如果参数是null  
			        if (_date_time == "null"){
						return "N/A";
					}
			        //如果字符串没有utc字符
			        if (_date_time.indexOf("UTC") < 0){
						_date_time += " UTC+0000";
						//将’-‘替换成’/‘兼容ie浏览器
						_date_time = _date_time.replace(/\-/g,'/')
						//将字符串转换成时间对象
						temp_date = new Date(_date_time);
					}
					 
				}else{//如果不是字符串
						temp_date = _date_time;
					}
				//返回正确格式的时间字符
			    function to_2_str(_value) {
			        if (_value < 10)
			            return "0" + _value;
			        else
			            return _value;
			    };
				//获取时区的毫秒数
				var temp = new Date(temp_date.getTime() + office);
				//获取带时区的时间
			    var date_str = temp.getUTCFullYear()
			        + "-"
			        + to_2_str(temp.getUTCMonth() + 1)
			        + "-"
			        + to_2_str(temp.getUTCDate())
			        + " "
			        + to_2_str(temp.getUTCHours())
			        + ":"
			        + to_2_str(temp.getUTCMinutes())
			        + ":"
			        + to_2_str(temp.getUTCSeconds())
					+ " " + _zone;
			    return date_str;
			},
      //将当前时间转换成零时区时间
			change_time_zone(time_zone){
        // console.log(time_zone)
        let parameter;
				// console.log(parameter,time_zone)
				function to_2_str(_value) {
			    	if (_value < 10){
						return "0" + _value;
					}   
			    	else{
						return _value;
					}       
				};
				//将时间毫秒数转换成时间对象
				var temp=new Date(time_zone);
        // console.log(temp.getUTCHours())


				//将0时区的信息拼接时间字符串
				 parameter = temp.getUTCFullYear()
			    + "-"
			    + to_2_str(temp.getUTCMonth() + 1)
			    + "-"
			    + to_2_str(temp.getUTCDate())
			    + " "
			    + to_2_str(temp.getUTCHours())
			    + ":"
			    + to_2_str(temp.getUTCMinutes())
			    + ":"
				+ to_2_str(temp.getUTCSeconds());

				return parameter
			},
    //截取时间字符
    intercept_time_character(value_c){
      let value=value_c.match(/[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d/gi);
        if(value){
          value.forEach((item,index)=>{
            //先转换为0时区
            value=this.change_time_zone(item+' '+window.sessionStorage.getItem('time_zone'))
            let time=value.split(' ');
            let time0=time[0]+'&nbsp;'+time[1];
            //转换为对应头部时区的时区
            value_c=value_c.replace(/[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d/,time0);
          })         
        }
        return value_c
    },
    //替换特殊字符
    replace_special_characters(value_special){
      // console.log(value_special)
      
      // console.log(value)
      let value=value_special.replace(/(\&lt\;|\&gt\;|\&amp\;|\&quot\;|\&yen\;|\&larr\;|\&rarr\;|\&rdquo\;|\&ldquo\;|\&nbsp\;)/gi,function($0, $1) {
        return {
        "&lt;": "<",
        "&gt;":">",
        "&amp;":"&",
        "&quot;":"'",
        "&yen;":"¥",
        "&larr;":"←",
        "&rarr;":"→",
        "&rdquo;":"”",
        "&ldquo;":"“",
        "&nbsp;":" "
        }[$1];
      });
      
      
        if(this.language_params==1){
          // alert(0)
          function str_unicode(str){
          var unid='\\u';
            for(var i=0,len=str.length;i<len;i++){
                if(i<len-1){
                  unid+=str.charCodeAt(i).toString(16)+'\\u';
                }else if(i===len-1){
                  unid+=str.charCodeAt(i).toString(16);
                }

            }
            return unid; 
          }

          function Unicode_Str(unicode){
              var result=[];
              var strArr=unicode.split('\\u');
              for(var i=0,len=strArr.length;i<len;i++){
                  if(strArr[i]){
                      result.push(String.fromCharCode(parseInt(strArr[i],16)))
                  }
              }
              // console.log(result.join(''))
              return result.join('');
          }
          var b=str_unicode(value);
          var c = b.replace(/u20/g, "ua0");
          // return Unicode_Str(c)
          value=Unicode_Str(c)
        }

      
        if(this.stra){
          this.stra.forEach((item,index)=>{
            // u_code=u_code.replace(/<gg>/,item)
            value=value.replace(/<gg>/,item)
          })
        }
        
        

        // return u_code
        console.log(value)
        return value

    },
    //提交规定格式数据
    submit(){
      let backups=this.value
      // console.log(this.value)
      if(this.value==undefined){
        this.value='<size></size>'
      }
      if(this.value.indexOf('<span')!=-1){       
        this.value=this.z_label(this.value);
        
        this.value=this.z_value_color(this.value);
        this.value=this.z_value_size(this.value);
        this.value=this.z_value_size_color(this.value);
        this.value=this.z_value_color_size(this.value);
        this.value=this.z_value_a(this.value);       
      }else{
        this.value=this.value.replace(/\<p\>/gi,'<size>');
        this.value=this.value.replace(/\<\/p\>/gi,'</size>');
        this.value=this.z_label(this.value);
        this.value=this.z_value_a(this.value);
        this.value=this.intercept_time_character(this.value);
        this.value=this.replace_special_characters(this.value);
        this.value=this.z_value_default_size(this.value);
        // this.value=this.z_value_a(this.value);
        return this.$emit('input_data',this.value,backups)
      }
      this.value=this.intercept_time_character(this.value);
      this.value=this.replace_special_characters(this.value)
      this.value=this.z_value_default_size(this.value);
      // console.log(this.value)
      this.$emit('input_data',this.value,backups);
    },
    //关闭弹框
    cancel(){
      this.$emit('close_project')
    
    },
  },
  directives: {
      drag: {
        inserted(el) {
          let drag_Box = el; //获取当前元素
          let dragBox = document.getElementsByClassName('tinymce')[0];
          // console.log(dragBox)
          dragBox.onmousedown = e => {
              //算出鼠标相对元素的位置
              let disX = e.clientX - drag_Box.offsetLeft;
              let disY = e.clientY - drag_Box.offsetTop;
              document.onmousemove = e => {
                // console.log(1)
                  //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                  let left = e.clientX - disX;
                  let top = e.clientY - disY;
                  //移动当前元素
                  drag_Box.style.left = left + "px";
                  drag_Box.style.top = top + "px";
              };
              document.onmouseup = e => {
                    //鼠标弹起来的时候不再移动
                    document.onmousemove = null;
                   //预防鼠标弹起来后还会循环（即预防鼠标放上去的时候还会移动）  
                  document.onmouseup = null;
              };
          };
        }
      }
  }
}

</script>
<style scoped>
  .size_num{
    outline:none
  }
  .tinymce{
   position: absolute;
    /* margin-top: -477px; */
    top: 26%;
    left: 35%;
    /* cursor: move; */
    width: 600px;
  }
 .tox-statusbar__branding {
    display: none;
  }
  button{
    outline: none;
  }
  .footer_tinymce{
    width: 600px;
    border: 1px solid #cccccc;
    border-top: none;
    background: #fff;
  }
  .btn_true_tinymce{
    border: none;
    background-color: #fff;
  }
  .btn_true_tinymce:hover{
    background-color: #cccccc;
  } 
  .btn_false_tinymce{
    border: none;
    background-color: #fff;
    float: right;
  }
  .btn_false_tinymce:hover{
    background-color: #cccccc;
  }
</style>